import React from 'react';
import ImageV2 from 'components_v2/common/ImageV2';
import PropTypes from 'prop-types';

import Listingheader from '../../../../home/components/common/ListingheaderV2';
import s from './PhotosSection.scss';

const altTags = ['Photos', 'Images', 'Pictures', 'Wallpapers', 'Stills'];

function PhotosSection({
  cards,
  title,
  loadMorePhotos,
  isWapView,
  hidePhotoMoreButton,
  headingName,
}) {
  const ImageElement = ImageV2;
  if (!cards || !cards.length) {
    return null;
  }
  const updatedCards = cards.map((card, i) => {
    if (i < 10) {
      card.alt = `${title} ${altTags[i % 5]}`;
    }
    return card;
  });

  return (
    <div className={s.photosection}>
      <Listingheader headingname={headingName} overrideClass={s.topicheading} />

      <div className={`${s.image_container} ${s.topicPhotosWrap}`}>
        {Array.isArray(updatedCards) &&
          !!updatedCards.length &&
          updatedCards.map((el, idx) => (
            <div key={idx} className={s.image_wrap}>
              <figure className={s.image}>
                <div className={s.content}>
                  <ImageElement
                    width="600"
                    msid={el.imageid}
                    placeHolderSrc="https://static.toiimg.com/photo/87458172.cms"
                    altTitle={el.alt || title}
                    offsetVertical={300}
                  />
                </div>
              </figure>
            </div>
          ))}
      </div>
      {typeof loadMorePhotos === 'function' &&
        !hidePhotoMoreButton && (
          <div className={`${!isWapView ? s.loadMore : s.bgwhite}`}>
            <button
              className={`${isWapView ? s.morebtn : ''}`}
              type="button"
              onClick={() => loadMorePhotos(33)}
            >
              Load More
            </button>
          </div>
        )}
    </div>
  );
}

PhotosSection.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.shape({})),
  title: PropTypes.string,
  isWapView: PropTypes.bool,
};

PhotosSection.defaultProps = {
  cards: [],
  title: '',
  isWapView: false,
};

export default PhotosSection;
